export interface FacilityTypeDto {
  id: number;
  name: string;
  description: string | null;
  isActive: boolean;
  hasSubTypes: boolean;
}
